import styled, { useTheme } from 'styled-components';
import useNoticeListPageController from '../../1_application/setting/noticeListPageController';
import { NoticeSummary } from '../../2_domain/notice/notice';
import toIDString from '../../lib/util/dateFormatter';
import Column from '../core/components/box/column';
import Row from '../core/components/box/row';
import SizedBox from '../core/components/box/sizedBox';
import { XCenter } from '../core/components/center';
import LXSimpleList from '../core/components/list/lxSimpleList';
import LXPagination from '../core/pagination/lxPagination';
import { LXbody, LXh4 } from '../core/texts/lxText';

const Padding = styled.div`
  padding: 20px 0px;
  cursor: pointer;
  border-bottom: ${(props) => `1px solid ${props.theme.colors.grayLine}`};

  &:hover {
    background-color: ${(props) => props.theme.colors.primaryBg};
  }
`;

const NoticeListPage = () => {
  const theme = useTheme();
  const c = useNoticeListPageController();

  const listItemBuilder = (notice: NoticeSummary, idx: number) => {
    return (
      <Padding key={idx} onClick={() => c.onNoticeClickHandler(notice)}>
        <Column>
          <LXh4 fontWeight={400}>{notice.title}</LXh4>
          <SizedBox height={4}></SizedBox>
          <Row>
          <LXbody color={theme.colors.caption}>{`${toIDString(
            notice.createdAt
          )}`}</LXbody>
          </Row>
        </Column>
      </Padding>
    );
  };

  return (
    <XCenter>
      <Column>
        <SizedBox height={80}></SizedBox>
        <LXSimpleList<NoticeSummary>
          datas={c.notices}
          itemBuilder={listItemBuilder}
          isLoading={c.isLoading}
        ></LXSimpleList>
        <SizedBox height={30}></SizedBox>
        <Row justifyContent="center">
          <LXPagination
            current={c.pageNumber}
            total={c.totalNotices}
            onChange={c.onPageNumberChagne}
            pageSize={c.pageSize}
          ></LXPagination>
        </Row>
      </Column>
    </XCenter>
  );
};

export default NoticeListPage;
